export default "__VITE_ASSET__BaAaaLbT__"